module.exports = __webpack_public_path__ + "static/assets/d04305129eadebdbd60bbbcefd876177.png";